import { useState } from "react";
import "./Communication.css";
import { sendNewsletterSignup } from "../../services/pangolinoApi";

const news = [
  {
    title:
      "The scale of Nigeria's involvement in the trans-national illegal pangolin",
    image: "/images/news1.jpg",
    category: "Publications",
    link: "#",
  },
];

export default function Communication() {
  const [email, setEmail] = useState("");
  const [agreed, setAgreed] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const normalizedEmail = email.trim().toLowerCase();

    if (!normalizedEmail) {
      setMessage("Please enter your email.");
      return;
    }

    if (!agreed) {
      setMessage("Please agree to receive newsletters.");
      return;
    }

    const subscribers = JSON.parse(
      localStorage.getItem("newsletterSubscribers") || "[]"
    );

    if (subscribers.includes(normalizedEmail)) {
      setMessage("This email is already subscribed!");
      return;
    }

    sendNewsletterSignup(normalizedEmail).catch((error) => {
      console.error("Failed to log newsletter signup:", error);
    });

    subscribers.push(normalizedEmail);

    localStorage.setItem(
      "newsletterSubscribers",
      JSON.stringify(subscribers)
    );

    setMessage("🎉 Thank you for subscribing! Your signup has been logged for the team.");

    setEmail("");
    setAgreed(false);
  };

  return (
    <section className="communication">
      <div className="communication-header">
        <h2>Communication</h2>
      </div>

      <div className="filters">
        <button className="active">All</button>
        <button>Publications</button>
      </div>

      <div className="featured-news">
        {news.map((item) => (
          <div key={item.title}>
            <img
              src={item.image}
              alt={item.title}
              className="featured-news-image"
            />

            <h3>{item.title}</h3>

            <a
              href={item.link}
              className="read-btn"
            >
              <span>Read More</span>
              <span className="arrow">→</span>
            </a>
          </div>
        ))}
      </div>

      <div className="newsletter">
        <h2>BE PART OF THE IMPACT!</h2>

        <form onSubmit={handleSubmit}>

          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label className="checkbox">
            <input
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
            />

            <span>
              I agree to receive updates and newsletters from Pangolino.
            </span>
          </label>

          <button type="submit">
            Subscribe
          </button>

          {message && (
            <p className="newsletter-message">
              {message}
            </p>
          )}

        </form>
      </div>
    </section>
  );
}